// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StaticMap_wrapper___K_5e","imageWrapper":"StaticMap_imageWrapper__5_uPa","pulse":"StaticMap_pulse__nu45k"};